import { useContext } from "react";
import { useTranslation } from "react-i18next";
import DeleteBookingsRequest from "../requests/DeleteBookingsRequest";
import { useBookingsEditingStore, useBookingsStore, useDateStore, useZoomStore } from "../../../stores/planner";
import { PlannerContext } from "../context/PlannerContext";
import { shallow } from "zustand/shallow";
import TeambookDialog from "../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const RepetitionDeleteQuestionDialog = ({
  open,
  setRepetitionQuestionDialogOpened,
  setBookings,
  closeCreationWindow,
  setEditWindowOpened,
  closeEditWindow,
  teams,
  teamId,
  usersRef,
  setProjects,
  setActiveProjects,
  activeProjects,
  filteredUsers,
}) => {
  const { t } = useTranslation();
  const { projects } = useContext(PlannerContext);
  const [zoom] = useZoomStore((state) => [state.zoom], shallow);

  const [bookings] = useBookingsStore((state) => [state.bookings], shallow);
  const [date] = useDateStore((state) => [state.date], shallow);

  const [bookingsEditing] = useBookingsEditingStore((state) => [state.bookingsEditing], shallow);

  const handleClose = () => {
    setRepetitionQuestionDialogOpened(false);
  };

  const handleNo = () => {
    DeleteBookingsRequest(
      bookingsEditing,
      date,
      zoom,
      setBookings,
      closeCreationWindow,
      bookings,
      setEditWindowOpened,
      false,
      closeEditWindow,
      teams,
      teamId,
      usersRef,
      filteredUsers,
      setProjects,
      setActiveProjects,
      projects,
      activeProjects
    );

    setRepetitionQuestionDialogOpened(false);
  };

  const handleYes = () => {
    DeleteBookingsRequest(
      bookingsEditing,
      date,
      zoom,
      setBookings,
      closeCreationWindow,
      bookings,
      setEditWindowOpened,
      true,
      closeEditWindow,
      teams,
      teamId,
      usersRef,
      filteredUsers,
      setProjects,
      setActiveProjects,
      projects,
      activeProjects
    );

    setRepetitionQuestionDialogOpened(false);
  };

  return (
    <TeambookDialog
      open={open}
      onClose={handleClose}
      title={" "}
      withCloseButton
      content={<p style={{marginBottom: 0}}>{t("planning.delete_all_repetitions")}</p>}
      actionButtons={[
        {text: t("no"), onClick: handleNo, id: "repetitionNo", type: "outlined" },
        {text: t("yes"), onClick: handleYes, id: "repetitionYes" },
      ]}
    />
  );
};

RepetitionDeleteQuestionDialog.propTypes = {
  open: PropTypes.bool,
  setRepetitionQuestionDialogOpened: PropTypes.func,
  setBookings: PropTypes.func,
  closeCreationWindow: PropTypes.func,
  setEditWindowOpened: PropTypes.func,
  closeEditWindow: PropTypes.func,
  teams: PropTypes.array,
  teamId: PropTypes.number,
  usersRef: PropTypes.object,
  setProjects: PropTypes.func,
  setActiveProjects: PropTypes.func,
  activeProjects: PropTypes.array,
  filteredUsers: PropTypes.array,
}

export default RepetitionDeleteQuestionDialog;
